import React from 'react';
import { func, string } from 'prop-types';
import './DeleteConfirmation.scss';

DeleteConfirmation.propTypes = {
  buttonText: string,
  confirmationDisclosure: string,
  confirmationText: string,
  onCancel: func,
  onRemove: func
};

function DeleteConfirmation(props) {
  const { buttonText, confirmationDisclosure, confirmationText, onCancel, onRemove } = props;

  return (
    <div className="delete__confirmation-container">
      <h4 className="delete__confirmation-heading">{confirmationText}</h4>
      <p className="delete__confirmation-disclosure">{confirmationDisclosure}</p>
      <div className="delete__confirmation-actions">
        <a className="delete__confirmation-cancel" onClick={onCancel}>
          Cancel
        </a>
        <button className="pxl-btn delete__confirmation-delete-btn" onClick={onRemove}>
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default DeleteConfirmation;
